// ---------- app (storefront) — pricing is SERVER-ONLY (DO /quote); no price math here ----------
const $=id=>document.getElementById(id);
let maskType="classic";
const FP_QUOTE_BASE=(window.FP_QUOTE_BASE||"").replace(/\/+$/,"");
let FP_MAXOD=26;
let FP_SHIP=null;
const FP_KLAVIYO_KEY=(window.FP_KLAVIYO_KEY||""), FP_KLAVIYO_LIST=(window.FP_KLAVIYO_LIST||"");
const isCap=()=>maskType==="cap";
function shipRegion(){var e=document.getElementById("fpRegion");return e?e.value:"us";}
function injectShip(){ if(document.getElementById("fpRegion"))return;
  var host=document.getElementById("fpPrice"); if(!host||!host.parentNode)return;
  var row=document.createElement("div"); row.className="fp-row"; row.style.marginTop="8px";
  row.innerHTML='<label style="font-weight:700;color:#13314f;font-size:13px">Ship to (choose your region)</label><div style="position:relative"><select id="fpRegion" style="width:100%;padding:11px 36px 11px 12px;border:2px solid #1b6ec2;border-radius:8px;font-size:15px;font-weight:600;background:#eef6ff;color:#13314f;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer"><option value="us">United States</option><option value="ca">Canada</option><option value="intl">International</option></select><span style="position:absolute;right:13px;top:50%;transform:translateY(-50%);pointer-events:none;color:#1b6ec2;font-size:11px">▼</span></div><div style="font-size:12px;color:#b4541a;margin-top:5px;font-weight:600">Please select your shipping region to see your total.</div>';
  host.parentNode.insertBefore(row,host);
  var sel=document.getElementById("fpRegion"); if(sel) sel.addEventListener("change",requestQuote);
}
function num(id){return parseFloat($(id).value);}
const isSct=()=>maskType==="sct"||maskType==="sct_tri";
const isTri=()=>maskType==="tri_v2"||maskType==="sct_tri";
function rowUp(el){while(el&&!(el.classList&&el.classList.contains("fp-row")))el=el.parentNode;return el;}
function applyTypeUI(){
  document.querySelectorAll(".sctRow").forEach(e=>e.style.display=isSct()?"":"none");
  document.querySelectorAll(".roundRow").forEach(e=>e.style.display=isSct()?"none":"");
  document.querySelectorAll(".triRow").forEach(e=>e.style.display=isTri()?"":"none");
  document.querySelectorAll(".hubRow").forEach(e=>e.style.display=maskType==="tri_v2"?"":"none");
  document.querySelectorAll(".cbRow").forEach(e=>e.style.display=isTri()?"none":"");
  $("coRow").style.display=maskType==="tri_v2"?"":"none";
  $("sensRow").style.display=isTri()?"none":"";
  const mi=$("mountInfo"); if(mi) mi.style.display=isSct()?"none":"";
  // ---- cap mode overrides ----
  const cap=isCap();
  document.querySelectorAll(".capRow").forEach(e=>e.style.display=cap?"block":"none");
  const dl=$("dlSvg");
  if(cap){
    document.querySelectorAll(".roundRow,.sctRow,.triRow,.hubRow,.cbRow").forEach(e=>e.style.display="none");
    ["sensRow","coRow"].forEach(id=>{const e=$(id); if(e) e.style.display="none";});
    if(mi) mi.style.display="none";
    document.querySelectorAll(".flatEng").forEach(e=>e.style.display="none"); const cro=$("customRow"); if(cro) cro.style.display="none";
    if(dl) dl.textContent="Download STL (free)"; if(window.FPCap3D)window.FPCap3D.show();
  } else {
    const rr=rowUp($("ratio")); if(rr) rr.style.display="";
    document.querySelectorAll(".flatEng").forEach(e=>e.style.display=""); const crc=$("customRow"); if(crc) crc.style.display=$("customOn").checked?"":"none";
    if(dl) dl.textContent="Download SVG (DIY)"; if(window.FPCap3D)window.FPCap3D.hide();
  }
}
$("mtSeg").addEventListener("click",e=>{const b=e.target.closest("button");if(!b)return;
  [...$("mtSeg").children].forEach(x=>x.classList.remove("on"));b.classList.add("on");
  maskType=b.dataset.v; applyTypeUI(); update();});
["od","fl","co","castid","secod","fittol","slotlen","designpct","hubdia","spinew","rimsct","ringw","cbw",
 "capOD","capWall","capFace","capSkirt","capClear","capRim","capBar"]
  .forEach(id=>{const e=$(id); if(e) e.addEventListener("input",update);});
$("sens").addEventListener("change",update);
$("customOn").addEventListener("change",()=>{$("customRow").style.display=$("customOn").checked?"":"none";update();});
$("customStr").addEventListener("input",update);
$("bf").addEventListener("input",()=>{$("bfVal").textContent=$("bf").value;update();});
$("ratio").addEventListener("input",()=>{$("ratioVal").textContent=parseFloat($("ratio").value).toFixed(2)+" : 1";update();});

function buildOpts(){
  const fl=num("fl"),bf=num("bf"),ratio=num("ratio");
  const period=(fl/bf)/25.4, slitW=period*(1/(1+ratio));
  const sens=$("sens").checked && !isTri();
  const angleFromVert=sens?85:30;
  const base={maskType,periodIn:period,slitW,stemSlit:ratio,angleFromVert,
              spineW:num("spinew")||0.2,centerBarW:num("cbw")||0.375,customText:(($("customOn")&&$("customOn").checked&&$("customStr"))?$("customStr").value.trim():""),
              _period:period,_slitW:slitW,_bf:bf,_ratio:ratio,_sens:sens};
  if(isSct())
    return Object.assign(base,{castingID:num("castid"),secondaryOD:num("secod"),
      fitTol:num("fittol")/25.4,rimSCT:num("rimsct")||0.18,ringW:num("ringw")||0.2});
  return Object.assign(base,{tubeOD:num("od"),slotLen:num("slotlen")||1.5,
      designPct:(num("designpct")||75)/100,
      centralObstructionIn:maskType==="tri_v2"?num("co"):0,
      hubMin:maskType==="tri_v2"?(num("hubdia")||0.56)/2:undefined});
}
function contourPath(verts){let d="M"+verts[0].x.toFixed(4)+" "+verts[0].y.toFixed(4);
  for(let i=0;i<verts.length;i++){const a=verts[i],b=verts[(i+1)%verts.length];
    if(Math.abs(a.b)<1e-9){d+=" L"+b.x.toFixed(4)+" "+b.y.toFixed(4);}
    else{const th=4*Math.atan(a.b),ch=Math.hypot(b.x-a.x,b.y-a.y),r=ch/(2*Math.sin(Math.abs(th)/2));
      const large=Math.abs(th)>Math.PI?1:0,sweep=a.b>0?1:0;
      d+=" A"+r.toFixed(4)+" "+r.toFixed(4)+" 0 "+large+" "+sweep+" "+b.x.toFixed(4)+" "+b.y.toFixed(4);}}
  return d+" Z";}
function toSVG(res,forDownload){const R=res.meta.R,S=R+0.4;
  const cut=res.contours.filter(c=>c.role!=="engrave"), eng=res.contours.filter(c=>c.role==="engrave");
  const cutD=cut.map(c=>contourPath(c.verts)).join(" "), engD=eng.map(c=>contourPath(c.verts)).join(" ");
  let inner;
  if(forDownload){
    inner=`<g id="cut"><path d="${cutD}" fill="none" stroke="#000000" stroke-width="0.01"/></g>`;
    if(engD) inner+=`<g id="engrave"><path d="${engD}" fill="none" stroke="#ff0000" stroke-width="0.01"/></g>`;
  } else {
    inner=`<path d="${cutD}" fill="#dce8f5" fill-rule="evenodd" stroke="#5b7fa6" stroke-width="0.02"/>`;
    if(engD) inner+=`<path d="${engD}" fill="#e8632a" fill-rule="evenodd" stroke="#e8632a" stroke-width="0.012"/>`;
  }
  const wh=forDownload?`width="${(2*S).toFixed(3)}in" height="${(2*S).toFixed(3)}in" `:`width="100%" `;
  return `<svg xmlns="http://www.w3.org/2000/svg" ${wh}viewBox="${-S} ${-S} ${2*S} ${2*S}"><g transform="scale(1,-1)">${inner}</g></svg>`;}
let lastRes=null;
function row(k,v){return `<div>${k}: <b>${v}</b></div>`;}
const NAMES={classic:"Classic Bahtinov",tri_v2:"Tri-Bahtinov",sct:"SCT Bahtinov",sct_tri:"SCT Tri-Bahtinov"};

// ---------- CAP (3D-print) client preview + actions ----------
const CN=96;
function cHP(v,a,b,c){var o=[],n=v.length;for(var i=0;i<n;i++){var cu=v[i],nx=v[(i+1)%n];var fc=a*cu[0]+b*cu[1]+c,fn=a*nx[0]+b*nx[1]+c;if(fc>=-1e-12)o.push(cu);if((fc>=0)!==(fn>=0)){var t=fc/(fc-fn);o.push([cu[0]+t*(nx[0]-cu[0]),cu[1]+t*(nx[1]-cu[1])]);}}return o;}
function cCirc(poly,R){var p=poly;for(var i=0;i<CN;i++){var a0=2*Math.PI*i/CN,a1=2*Math.PI*(i+1)/CN,P=[R*Math.cos(a0),R*Math.sin(a0)],Q=[R*Math.cos(a1),R*Math.sin(a1)];var a=-(Q[1]-P[1]),b=(Q[0]-P[0]),c=-(a*P[0]+b*P[1]);if(c<0){a=-a;b=-b;c=-c;}p=cHP(p,a,b,c);if(p.length<3)return [];}return p;}
function cAr(r){var s=0;for(var i=0;i<r.length;i++){var a=r[i],b=r[(i+1)%r.length];s+=a[0]*b[1]-b[0]*a[1];}return Math.abs(s)/2;}
function cStrips(R,period,width,dH,dV,offF){var hw=width/2,out=[];var REG={low:[[0,-1,-dH]],ul:[[-1,0,-dV],[0,1,-dH]],ur:[[1,0,-dV],[0,1,-dH]]};
  function emit(P0,u,reg){var nrm=[-u[1],u[0]],L=R+4;var P=function(t,o2){return [P0[0]+t*u[0]+o2*nrm[0],P0[1]+t*u[1]+o2*nrm[1]];};var v=[P(-L,hw),P(L,hw),P(L,-hw),P(-L,-hw)];for(var q=0;q<REG[reg].length;q++){var r=REG[reg][q];v=cHP(v,r[0],r[1],r[2]);}if(v.length<3)return;v=cCirc(v,R);if(v.length<3||cAr(v)<1e-3)return;out.push(v);}
  var th=30*Math.PI/180,k=-Math.floor(2*R/period)-2;while(k*period<=2*R+1){var cx=(k+offF)*period;if(Math.abs(cx)<=R+period)emit([cx,0],[0,1],"low");k++;}
  var dR=[Math.sin(th),Math.cos(th)],pR=[-dR[1],dR[0]],a0=dV*pR[0]+dH*pR[1],m=-Math.floor(2*R/period)-2;while(m*period<=2*R+1){var off=a0+(m+offF)*period,P0=[off*pR[0],off*pR[1]];emit(P0,dR,"ur");emit([-P0[0],P0[1]],[-dR[0],dR[1]],"ul");m++;}return out;}
function capParams(){return {frontOD:num("capOD"),fl:num("fl"),bf:num("bf"),ratio:num("ratio")||1,
  wall:num("capWall")||2,faceThk:num("capFace")||1.8,skirtDepth:num("capSkirt")||12,
  clearance:num("capClear")||0.3,rim:num("capRim")||3,centerBar:num("capBar")||3};}
function capUpdate(){
  const od=num("capOD"), pe=$("fpPrice"), ob=$("orderBtn");
  if(!(od>=40&&od<=150)){$("prev").innerHTML='<div style="color:#e8632a;padding:44px 12px;text-align:center;font:13px sans-serif">Cap masks fit 40&ndash;150&nbsp;mm front O.D.<br>Larger scopes use the flat laser types above.</div>';$("meta").innerHTML="";$("note").innerHTML="";if(pe)pe.textContent="";if(ob)ob.disabled=true;return;}
  const p=capParams(),fitR=od/2,Rf=fitR+p.wall,R=Math.max((od-2*p.rim)/2,5);
  const ratio=num("ratio")||1,minBar=2.5,minSlit=0.5; let period=p.fl/p.bf; const pMin=Math.max(minBar*(1+ratio)/ratio,minSlit*(1+ratio)); let clamp=false; if(period<pMin){period=pMin;clamp=true;}
  const slitW=period/(1+ratio),bar=period-slitW,effBF=p.fl/period,dH=p.centerBar/2;
  const sl=cStrips(R,period,slitW,dH,dH,0), S=Rf+3;
  const path=sl.map(r=>"M"+r.map(q=>q[0].toFixed(2)+" "+(-q[1]).toFixed(2)).join(" L")+" Z").join(" ");
  $("prev").innerHTML='<svg width="100%" viewBox="'+(-S)+' '+(-S)+' '+(2*S)+' '+(2*S)+'"><circle r="'+Rf.toFixed(2)+'" fill="#dce8f5" stroke="#5b7fa6" stroke-width="0.4"/><circle r="'+fitR.toFixed(2)+'" fill="none" stroke="#e8632a" stroke-width="0.4" stroke-dasharray="3 2"/><path d="'+path+'" fill="#0f1622"/></svg>';
  $("meta").innerHTML=row("Front O.D. (slips over)",od.toFixed(0)+" mm")+row("Cap face O.D.",(Rf*2).toFixed(1)+" mm")+row("Skirt bore",(od+p.clearance).toFixed(1)+" mm")+row("Slit / bar",slitW.toFixed(2)+" / "+bar.toFixed(2)+" mm")+row("Effective BF",effBF.toFixed(0))+row("Slits",sl.length);
  $("note").innerHTML="Slips over your scope's front (dew shield/tube). Print in black PLA or PETG, 0.2&nbsp;mm layers, face-down. The STL download is free; or we print &amp; ship it for you.";
  $("warn").textContent=clamp?("Pattern coarsened to keep printable 2.5&nbsp;mm bars (effective BF "+effBF.toFixed(0)+").").replace(/&nbsp;/g," "):"";
  requestCapQuote(p); if(window.FPCap3D)window.FPCap3D.update(p);
}
let capQTimer=null;
function requestCapQuote(p){const pe=$("fpPrice"),ob=$("orderBtn");
  if(!FP_QUOTE_BASE){if(pe)pe.innerHTML='<span class="muted">Ordering coming soon.</span>';if(ob)ob.disabled=true;return;}
  if(pe)pe.innerHTML='<span class="muted">Calculating…</span>'; clearTimeout(capQTimer);
  capQTimer=setTimeout(()=>{fetch(FP_QUOTE_BASE+"/cap/quote",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({params:p,region:shipRegion()})})
    .then(r=>r.json()).then(d=>{
      if(d&&d.ok){ if(pe)pe.innerHTML='Printed &amp; shipped: <b>$'+Number(d.printedPrice).toFixed(2)+'</b> <span class="muted">+ $'+Number(d.shipping.amount).toFixed(2)+' '+d.shipping.label+' shipping</span>';
        if(ob){ob.disabled=false;ob.textContent="Order printed & shipped";} }
      else { if(pe)pe.innerHTML='<span class="muted">Unavailable.</span>'; if(ob)ob.disabled=true; }
    }).catch(()=>{if(pe)pe.innerHTML='<span class="muted">Unavailable.</span>';});},300);
}
// newsletter opt-in gate (shared by the free downloads: cap STL and flat SVG)
function fpSubscribe(email){ if(!FP_KLAVIYO_KEY||!FP_KLAVIYO_LIST) return Promise.resolve(true);
  return fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+FP_KLAVIYO_KEY,{method:"POST",headers:{"Content-Type":"application/json","revision":"2024-10-15"},
    body:JSON.stringify({data:{type:"subscription",attributes:{profile:{data:{type:"profile",attributes:{email:email,subscriptions:{email:{marketing:{consent:"SUBSCRIBED"}}}}}},custom_source:"Bahtinov generator"},relationships:{list:{data:{type:"list",id:FP_KLAVIYO_LIST}}}}})
  }).then(r=>r.ok||r.status===202).catch(()=>false);
}
let pendingDownload=null;
function openGate(fn){ pendingDownload=fn; const g=$("fpGate"); if(g){$("gateMsg").textContent="";g.style.display="flex";} else fn(); }
function closeGate(){ const g=$("fpGate"); if(g) g.style.display="none"; }
function gateGo(){ const em=($("gateEmail").value||"").trim(), ok=$("gateOptin").checked;
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){$("gateMsg").textContent="Enter a valid email.";return;}
  if(!ok){$("gateMsg").textContent="Please tick the box to subscribe and download.";return;}
  $("gateMsg").textContent="Subscribing…"; fpSubscribe(em).then(()=>{$("gateMsg").textContent="";closeGate();if(pendingDownload)pendingDownload();});
}
function fpTrack(kind,type,format){ try{ if(!FP_QUOTE_BASE)return; fetch(FP_QUOTE_BASE+"/track",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({kind:kind,type:type,format:format}),keepalive:true}); }catch(e){} }
function downloadCapSTL(){ const p=capParams(); fpTrack("download","cap","stl");
  fetch(FP_QUOTE_BASE+"/cap/stl",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({params:p})})
  .then(r=>r.blob()).then(bl=>{const el=document.createElement("a");el.href=URL.createObjectURL(bl);el.download="farpoint-cap-"+Math.round(p.frontOD)+"mm-fl"+Math.round(p.fl)+".stl";document.body.appendChild(el);el.click();el.remove();});
}
function capOrder(ob){ const p=capParams(); ob.disabled=true; const t=ob.textContent; ob.textContent="Preparing checkout…";
  fetch(FP_QUOTE_BASE+"/cap/order",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({params:p,region:shipRegion()})})
  .then(r=>r.json()).then(d=>{ if(d&&d.ok&&d.invoiceUrl){ waitInvoice(d.invoiceUrl,ob).then(()=>{window.location.href=d.invoiceUrl;}); }
    else { alert("Sorry, couldn't start the order: "+((d&&d.error)||"unknown")); ob.disabled=false; ob.textContent=t; } })
  .catch(e=>{ alert("Order error: "+e.message); ob.disabled=false; ob.textContent=t; });
}

let quoteTimer=null;
function requestQuote(){
  if(isCap()){ requestCapQuote(capParams()); return; }
  const pe=$("fpPrice"), ob=$("orderBtn");
  if(!FP_QUOTE_BASE){ if(pe)pe.innerHTML='<span class="muted">Online ordering coming soon.</span>'; if(ob)ob.disabled=true; return; }
  if(pe) pe.innerHTML='<span class="muted">Calculating price…</span>';
  clearTimeout(quoteTimer);
  quoteTimer=setTimeout(async()=>{
    try{
      const r=await fetch(FP_QUOTE_BASE+"/quote",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({params:buildOpts(),region:shipRegion()})});
      const d=await r.json();
      if(d&&d.ok){ if(typeof d.maxOrderOD==="number")FP_MAXOD=d.maxOrderOD;
        var _h="Your price: <b>$"+Number(d.price).toFixed(2)+"</b>";
        if(d.shipping){FP_SHIP=d.shipping;_h+=' <span class="muted">+ $'+Number(d.shipping.amount).toFixed(2)+" "+d.shipping.label+" shipping</span>";}
        if(pe)pe.innerHTML=_h;
        if(ob){ if(d.orderable===false){ob.disabled=true;ob.textContent="Too large to laser-cut";}else{ob.disabled=false;ob.textContent="Order this mask";} } }
      else { if(pe)pe.innerHTML='<span class="muted">Price unavailable.</span>'; if(ob)ob.disabled=true; }
    }catch(e){ if(pe)pe.innerHTML='<span class="muted">Price unavailable.</span>'; if(ob)ob.disabled=true; }
  },300);
}
function update(){
  try{
    injectShip();
    if(isCap()){ capUpdate(); return; }
    const o=buildOpts(),res=MaskEngine.genMask(o),m=res.meta;lastRes=res;
    $("prev").innerHTML=toSVG(res,false);
    const slitMM=(o._slitW*25.4).toFixed(2),perMM=(o._period*25.4).toFixed(2);
    const sensTxt=o._sens?" (85° extra-sensitive)":"";
    let h=row("Mask type",NAMES[maskType]+sensTxt);
    if(isSct()){
      h+=row("Mask O.D.",m.maskOD.toFixed(2)+"″ (casting ID − fit)");
      h+=row("Center hole O.D.",m.holeOD>0?m.holeOD.toFixed(2)+"″":"none");
      h+=row("Connecting ring O.D.",m.ringOD>0?m.ringOD.toFixed(2)+"″":"none");
      h+=row("Fit clearance",(m.fitTol*25.4).toFixed(1)+" mm");
    }else{
      h+=row("Design tube O.D.",m.designTubeOD+"″");
      h+=row("Mask O.D.",m.maskOD.toFixed(2)+"″");
      h+=row("Fits tube O.D.",m.tubeMinOD.toFixed(1)+"–"+m.tubeMaxOD.toFixed(1)+"″");
    }
    h+=row("Slit width",slitMM+" mm ("+o._slitW.toFixed(3)+"″)");
    h+=row("Grating period",perMM+" mm");
    h+=row("Bahtinov factor",o._bf);
    $("meta").innerHTML=h;
    let note;
    if(!isSct())
      note="<b>Mounting:</b> three rubber grommets (McMaster #9307K14) press into the slots and slide to fit tube O.D. "
        +m.tubeMinOD.toFixed(1)+"–"+m.tubeMaxOD.toFixed(1)+"″. A 1/4″ peg or plastic screw presses into each grommet to hang the mask on the front of the tube.";
    else
      note="<b>Mounting:</b> drops into the front casting; the center hole clears the secondary mirror housing. Sized for a friction fit at the chosen clearance.";
    note+=" Units: inches, true scale. Engraved with www.FarpointAstro.com.";
    note+=" Maximum laser-cut size: "+FP_MAXOD+"″ O.D. — larger designs are download-only (DIY).";
    $("note").innerHTML=note;
    let w="";
    if(m.maskOD>46.05) w="⚠ Mask O.D. "+m.maskOD.toFixed(1)+"″ exceeds the 46″ material limit.";
    else if(m.maskOD>FP_MAXOD) w="ℹ Mask O.D. "+m.maskOD.toFixed(1)+"″ is over our "+FP_MAXOD+"″ laser-cut limit — this size is download-only (DIY).";
    else if(o._slitW<0.04) w="⚠ Very fine slits ("+slitMM+" mm) — may be hard to cut. Lower the Bahtinov factor, shorten focal length, or raise the stem:slit ratio.";
    if(isSct()){
      if(!(o.castingID>0)) w="⚠ Enter the front casting inner diameter.";
      else if(o.secondaryOD>0 && o.secondaryOD+o.fitTol >= o.castingID-o.fitTol) w="⚠ Secondary hole is larger than the mask — check the casting ID and secondary O.D.";
    }else if(o._sens){ w=w||"ℹ 85° masks need software (e.g. Bahtinov Grabber) to read — not for visual focusing."; }
    $("warn").textContent=w;
    requestQuote();
  }catch(err){$("warn").textContent="Error: "+err.message;console.error(err);}
}
const orderBtn=$("orderBtn");
if(orderBtn) orderBtn.addEventListener("click",async()=>{
  if(!FP_QUOTE_BASE)return;
  if(isCap()) return capOrder(orderBtn);
  orderBtn.disabled=true; const t=orderBtn.textContent; orderBtn.textContent="Starting order…";
  try{
    const r=await fetch(FP_QUOTE_BASE+"/order",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({params:buildOpts(),region:shipRegion()})});
    const d=await r.json();
    if(d&&d.ok&&d.invoiceUrl){ orderBtn.textContent="Preparing checkout…"; await waitInvoice(d.invoiceUrl, orderBtn); window.location.href=d.invoiceUrl; return; }
    alert("Sorry, the order couldn't be started: "+((d&&d.error)||"unknown error")); orderBtn.disabled=false; orderBtn.textContent=t;
  }catch(e){ alert("Order error: "+e.message); orderBtn.disabled=false; orderBtn.textContent=t; }
});
async function waitInvoice(url,btn){
  for(var i=0;i<45;i++){
    try{ var t=await fetch(url,{cache:"no-store"}).then(function(r){return r.text();});
      if(!/not available yet|Something went wrong/i.test(t)) return true; }catch(e){}
    if(btn) btn.textContent="Preparing checkout… "+(i+1)+"s";
    await new Promise(function(r){setTimeout(r,1000);});
  }
  return false;
}
function download(name,text,mime){const blob=new Blob([text],{type:mime});const a=document.createElement("a");
  a.href=URL.createObjectURL(blob);a.download=name;document.body.appendChild(a);a.click();a.remove();}
const dl=$("dlSvg");
if(dl) dl.addEventListener("click",()=>{
  openGate(()=>{
    if(isCap()){ downloadCapSTL(); return; }
    if(!lastRes)return; const o=buildOpts();
    const tag=isSct()?("ID"+o.castingID):("OD"+o.tubeOD);
    download(`farpoint-${maskType}${o._sens?"-85deg":""}-${tag}.svg`,toSVG(lastRes,true),"image/svg+xml"); fpTrack("download",maskType,"svg");
  });
});
const gs=$("gateSubmit"); if(gs) gs.addEventListener("click",gateGo);
const gc=$("gateCancel"); if(gc) gc.addEventListener("click",closeGate);
applyTypeUI();update();
